

import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { GlobalLoaderProvider } from "./Context/GlobalLoaderContext";
import reportWebVitals from "./reportWebVitals";
import { HashRouter, BrowserRouter as Router } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';

ReactDOM.render(
  <React.StrictMode>
    <GlobalLoaderProvider>
      <App />
    </GlobalLoaderProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
